import React from "react";
import { Box, Typography } from "@mui/material";

// A label/value row under a GroupTitle: the field name on the left in text.secondary, the value on
// the right, medium-weight. An unset value shows an em dash rather than collapsing the row.
const SpecRow = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 1,
      py: "3px",
    }}
  >
    <Typography sx={{ fontSize: "0.875rem", color: "text.secondary" }}>
      {label}
    </Typography>
    <Typography component="span" sx={{ fontSize: "0.9375rem", fontWeight: 500 }}>
      {value}
    </Typography>
  </Box>
);

export default SpecRow;
